// extracted by mini-css-extract-plugin
export default {"suggestions":"GoalEditor_suggestions__CSZFg"};